export default __webpack_public_path__ + "static/media/lynnGame2.d266ebf9.png";